import {
  Button,
  DynamicPageHeader,
  FlexBox,
  FlexBoxJustifyContent,
  FlexBoxWrap,
  MessageStrip
} from '@ui5/webcomponents-react';
import { CreateQueryContext } from 'components/CreateQuery/CreateQueryContext/CreateQueryContext';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './CreateQueryHeaderContent.jss';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';
import MessageStripDesign from '@ui5/webcomponents/dist/types/MessageStripDesign.js';

interface MessageStripState {
  design?: MessageStripDesign;
  message?: string;
}

export const CreateQueryHeaderContent: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [messageStrip, setMessageStrip] = useState<MessageStripState>({});
  const { useClipboardStore } = useContext(CreateQueryContext);
  const { enabled, pasteFromClipboard } = useClipboardStore();

  const handlePasteFromClipboard = async () => {
    if (!navigator.clipboard) {
      setMessageStrip({
        design: MessageStripDesign.Critical,
        message: t('create-query-paste-from-clipboard-not-available')
      });
    } else {
      const text = await navigator.clipboard.readText().catch(() => {
        setMessageStrip({
          design: MessageStripDesign.Critical,
          message: t('create-query-paste-from-clipboard-no-permission')
        });
      });
      if (text) {
        pasteFromClipboard(text);
      }
    }
  };

  const handleCloseWarning = () => setMessageStrip({});

  return (
    <DynamicPageHeader className={classes.pageHeader}>
      <FlexBox
        className={classes.wrapper}
        wrap={FlexBoxWrap.Wrap}
        justifyContent={FlexBoxJustifyContent.End}
      >
        <Button
          data-help-id="create-query-paste-from-clipboard"
          disabled={!enabled}
          onClick={handlePasteFromClipboard}
          tooltip={t('create-query-paste-from-clipboard-enabled')}
          design={ButtonDesign.Emphasized}
        >
          {t('create-query-paste-from-clipboard')}
        </Button>
      </FlexBox>
      <FlexBox className={`${classes.wrapper} ${classes.wrapperSpacer}`} wrap={FlexBoxWrap.Wrap}>
        {messageStrip.design ? (
          <MessageStrip design={messageStrip.design} onClose={handleCloseWarning}>
            {messageStrip.message}
          </MessageStrip>
        ) : null}
      </FlexBox>
    </DynamicPageHeader>
  );
};
